import Listing from '../../purchase-request/Listing';

const TPListing = () => {
  return <Listing type="transfer_pricing" />;
};

export default TPListing;
